/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-06-16 21:04:20
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-27 14:37:55
 * @FilePath: \myapp\src\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import pako from 'pako'

// b64Data-->传入加密的数据进行解密
export function unzip(b64Data) {
    let strData = window.atob(b64Data)
    // Convert binary string to character-number array
    const charData = strData.split('').map(function (x) { return x.charCodeAt(0) })
    // Turn number array into byte-array
    const binData = new Uint8Array(charData)
    // // unzip
    const data = pako.inflate(binData)
    // Convert gunzipped byteArray back to ascii string:  var i;
    var chunk = 50 * 1024;
    var i;
    var res
    for (i = 0; i < data.length / chunk; i++) {
        res += String.fromCharCode.apply(null, data.slice(i * chunk, (i + 1) * chunk));
    }
    res += String.fromCharCode.apply(null, data.slice(i * chunk));
    return res.replace('undefined', '');
    // return strData
}

// 加密
function zip(str) {
    if (typeof str !== 'string') {
        str = JSON.stringify(str)
    }
    const binaryString = pako.gzip(str, { to: 'string' })
    return window.btoa(binaryString)
}
